// extracted by mini-css-extract-plugin
export default {"container":"OverallPnlBox_container__EqLXU","rewardsWrapper":"OverallPnlBox_rewardsWrapper__wakXF"};